import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up",
  "use": "icon-arrow-up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-up\"><defs><style type=\"text/css\"></style></defs><path d=\"M554.666667 853.333333 469.333333 853.333333 469.333333 341.333333 234.666667 576 174.08 515.413333 512 177.493333 849.92 515.413333 789.333333 576 554.666667 341.333333 554.666667 853.333333Z\" p-id=\"17297\" fill=\"#1afa29\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol